export const testimonials = [
  {
    id: 1,
    photo: "img/testimonial-1.png",
    title: "Very satisfied.",
    message: 'This is an awesome Medical Center.',
    rating: 5,
  },
  {
    id: 2,
    photo: "img/testimonial-2.png",
    title: "This is amazing!!1!",
    message: 'This is an awesome Medical Center.',
    rating: 4,
  },
  {
    id: 3,
    photo: "img/testimonial-2.png",
    title: "This is amazing!!1!",
    message: 'This is an awesome Medical Center.',
    rating: 3,
  },
];
